import JQuery from "jquery";

class CheckManagerFields {
  /**
   * Check passwords' validity, return true on error
   * @param target
   * @param firstPasswordRow
   * @param secondPasswordRow
   * @returns {boolean} True on error
   * @constructor
   */
  public static CheckPassword(
    target: JQuery<HTMLElement>,
    firstPasswordRow: JQuery<HTMLElement>,
    secondPasswordRow: JQuery<HTMLElement>,
  ): boolean {
    const currentPassword = target.val().toString().trim();
    const firstPassword = firstPasswordRow.val().toString().trim();
    const secondPassword = secondPasswordRow.val().toString().trim();
    const parentNode = target.parent();
    const shortError = $(".short-password-message").text();
    const longError = $(".long-password-message").text();
    const differentError = $(".different-passwords-message").text();
    // Remove previously displayed error messages
    CheckManagerFields.DisplayError(parentNode, "");
    if (currentPassword.length < 5) {
      if (firstPassword !== "" || secondPassword !== "") {
        CheckManagerFields.SetErrorInfo(parentNode);
        CheckManagerFields.DisplayError(parentNode, shortError);
        return true;
      }
      CheckManagerFields.DisplayError(parentNode, "");
      CheckManagerFields.SetCheckedInfo(parentNode);
      return true;
    }
    if (currentPassword.length > 80) {
      CheckManagerFields.SetErrorInfo(parentNode);
      CheckManagerFields.DisplayError(parentNode, longError);
      return true;
    }
    if (firstPassword !== "" && secondPassword !== "") {
      if (firstPassword !== secondPassword) {
        CheckManagerFields.DisplayError(parentNode, differentError);
        CheckManagerFields.SetErrorInfo(firstPasswordRow.parent());
        CheckManagerFields.SetErrorInfo(secondPasswordRow.parent());
        return true;
      }
      CheckManagerFields.DisplayError(firstPasswordRow.parent(), "");
      CheckManagerFields.DisplayError(secondPasswordRow.parent(), "");
      CheckManagerFields.SetCheckedInfo(firstPasswordRow.parent());
      CheckManagerFields.SetCheckedInfo(secondPasswordRow.parent());
      return false;
    }
    CheckManagerFields.DisplayError(parentNode, "");
    CheckManagerFields.SetCheckedInfo(parentNode);
    return true;
  }

  /**
   * Check display name field validity, returns true on error
   * @param target
   * @param firstName
   * @param lastName
   * @returns {boolean} return True on error
   * @constructor
   */
  public static CheckName(
    target: JQuery<HTMLElement>,
    firstName: string,
    lastName: string,
  ): boolean {
    const currentInput = target.val().toString().trim();
    const parentNode = target.parent();
    const emptyError = $(".empty-name-message").text();
    // Remove previously displayed error messages
    CheckManagerFields.DisplayError(parentNode, "");
    // if the name field is empty, display an error
    if (currentInput.trim().length === 0) {
      CheckManagerFields.SetErrorInfo(parentNode);
      CheckManagerFields.DisplayError(parentNode, emptyError);
      return true;
    }
    // if none of the names field are empty, display that is correct
    if (firstName !== "" && lastName !== "") {
      CheckManagerFields.DisplayError(parentNode, "");
      CheckManagerFields.SetCheckedInfo(parentNode);
      return false;
    }
    // if none the other name field is empty but not this one, don't display an error
    CheckManagerFields.DisplayError(parentNode, "");
    CheckManagerFields.SetCheckedInfo(parentNode);
    return true;
  }

  public static SetLoadingInfo(focusedElement: JQuery<HTMLElement>): void {
    const input = focusedElement.find("input");
    const label = focusedElement.find("label");
    const checkLoader = focusedElement.find(".check-loader");
    const inputIcon = focusedElement.find("svg");
    checkLoader.removeClass("hide");
    inputIcon.show();
    inputIcon.attr("class", "fa fa-circle-notch color--default");
    input
      .removeClass("border--error border--confirmed")
      .addClass("border--default");
    label
      .removeClass("color--error color--confirmed")
      .addClass("color--default");
  }

  public static SetErrorInfo(focusedElement: JQuery<HTMLElement>): void {
    const input = focusedElement.find("input");
    const label = focusedElement.find("label");
    const checkLoader = focusedElement.find(".check-loader");
    const inputIcon = checkLoader.find("svg");
    inputIcon.hide();
    input
      .removeClass("border--default border--confirmed")
      .addClass("border--error");
    label
      .removeClass("color--default color--confirmed")
      .addClass("color--error");
  }

  public static SetCheckedInfo(focusedElement: JQuery<HTMLElement>): boolean {
    const input = focusedElement.find("input");
    const label = focusedElement.find("label");
    const checkLoader = focusedElement.find(".check-loader");
    const inputIcon = checkLoader.find("svg");
    const isOnAccountPage = $('form[name="account_form"]').length;
    checkLoader.addClass("hide");
    /* Focusing a password element on account page */
    if (
      isOnAccountPage === 1 &&
      focusedElement.find("input[type=password]").length > 0
    ) {
      inputIcon.show();
      inputIcon.attr("class", "fa fa-check color--confirmed");
      input
        .removeClass("border--error border--default")
        .addClass("border--confirmed");
      label
        .removeClass("color--confirmed color--error")
        .addClass("color--default");
      /* if both passwords are empty remove input icon and put class to default */
      const passwordRow = $("#passwordRow");
      const firstPassword = passwordRow.find("input")[0].value.trim();
      const secondPassword = passwordRow.find("input")[1].value.trim();
      if (firstPassword.length === 0 && secondPassword.length === 0) {
        focusedElement
          .parent()
          .find("div input[type=password]")
          .removeClass("border--error border--confirmed")
          .addClass("border--default");
        focusedElement
          .parent()
          .find("label")
          .removeClass("color--error color--confirmed")
          .addClass("color--default");
        inputIcon.hide();
      }
    } else if (isOnAccountPage === 0) {
      /* On signup page */
      inputIcon.show();
      inputIcon.attr("class", "fa fa-check color--confirmed");
      input
        .removeClass("border--error border--default")
        .addClass("border--confirmed");
      label
        .removeClass("color--confirmed color--error")
        .addClass("color--default");
      if (
        input.val() === undefined ||
        input.val().toString().trim().length === 0
      ) {
        inputIcon.hide();
      }
      return true;
    } else {
      /* On account page */
      input
        .removeClass("border--error border--confirmed")
        .addClass("border--default");
      label
        .removeClass("color--confirmed color--error")
        .addClass("color--default");
      inputIcon.attr("class", "");
      inputIcon.hide();
      return true;
    }
    return true;
  }

  public static SetEmptyInfo(focusedElement: JQuery<HTMLElement>): void {
    const checkLoader = focusedElement.find(".check-loader");
    checkLoader.find("svg").hide();
    focusedElement
      .find("input")
      .removeClass("border--error border--confirmed")
      .addClass("border--default");
    focusedElement
      .find("label")
      .removeClass("color--error color--confirmed")
      .addClass("color--default");
  }

  public static DisplayError(
    focusedElement: JQuery<HTMLElement>,
    message: string,
  ) {
    const errorText = focusedElement.find(".error-text");
    errorText.text(message);
    errorText[0].style.opacity = message.trim() === "" ? "0" : "1";
  }
}

export default CheckManagerFields;
